import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import NumberFormat from "react-number-format";

const ContactUs = ({ t }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <React.Fragment>
      {/* Begin: Contanct Box */}
      <div className="contact-box">
        <div className="container pb-0">
          <div className="row">
            <div className="col-md-5">
              <div className="front-title-block">
                <h4 className="subtitle">{t("contact_us.contact")}</h4>
                <h3 className="title">
                  {t("contact_us.let’s_talk_about")}{" "}
                  <span className="text-primary d-block">
                    {t("contact_us.everything!")}
                  </span>
                </h3>
                <p className="common-para">
                  {t("contact_us.send_us_an_email!")}
                </p>
              </div>
              <div className="contact-address">
                <b className="i-address">
                  {t("contact_us.iLife_technologies")}
                </b>
                <p>Playa Vista, CA 90094, US</p>
                <div className="call-mail">
                  <div className="call-div">
                    <span className="svg-icon">
                      <svg
                        width="22px"
                        height="22px"
                        viewBox="0 0 22 22"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>{t("contact_us.path")}</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <g
                            className="fill"
                            transform="translate(-375.000000, -598.000000)"
                            fillRule="nonzero"
                          >
                            <g transform="translate(375.000000, 230.000000)">
                              <g transform="translate(0.000000, 258.000000)">
                                <g transform="translate(0.000000, 108.000000)">
                                  <path
                                    d="M6.20456127,2.00387764 C7.63673848,2.07711564 8.83114545,3.15468859 9.0354615,4.59796653 C9.15281934,5.48621058 9.37046322,6.35835074 9.68339231,7.19548736 C10.0975999,8.29545198 9.83267359,9.53546589 9.00097865,10.3750116 L8.28022308,11.094493 C9.46208547,12.9452867 11.0353681,14.5157873 12.8894402,15.6955595 L13.6141778,14.9721157 C14.4512224,14.1458497 15.6934324,13.8813918 16.7930774,14.2940194 C17.6339642,14.607243 18.5076489,14.8245021 19.4064465,14.942876 C20.8618533,15.1478353 21.9477533,16.3667952 21.9989697,17.793739 L21.9999264,20.9790531 C22.0033726,21.8265847 21.6487134,22.636293 21.0230787,23.2092551 C20.397444,23.7822172 19.5588162,24.0653323 18.6951167,23.9872483 C15.4459468,23.6348236 12.3248904,22.5265149 9.59054667,20.7563866 C7.03749351,19.1369384 4.8729501,16.9762216 3.25539198,14.4350846 C1.4709032,11.685335 0.360379504,8.55464473 0.0122479426,5.28099223 C-0.0639293876,4.43950685 0.217700096,3.60480563 0.788340843,2.98078673 C1.35893163,2.35682246 2.16595791,2.00094422 3.01344223,2 L6.02435515,2 L6.20456127,2.00387764 Z M6.0385601,4.00661484 L3.01456479,4.00666184 C2.73231985,4.00697651 2.46322711,4.12563963 2.27300381,4.33365655 C2.08279023,4.54166285 1.98891374,4.81989659 2.01276536,5.08474062 C2.32601404,8.02932198 3.32970524,10.8588395 4.94728412,13.3514657 C6.41132557,15.6513674 8.36469402,17.6012825 10.6764883,19.0677466 C13.154855,20.6721171 15.9756655,21.6738065 18.8941589,21.9905293 C19.1760233,22.0159578 19.4555659,21.9215861 19.6641108,21.7305988 C19.8726557,21.5396114 19.9908755,21.2697086 19.9897184,20.9831256 L19.9900277,17.9482442 C20.002687,17.4389496 19.6309843,17.0010295 19.1346152,16.9310865 C18.0944911,16.7941472 17.0732245,16.5401889 16.0880285,16.1732081 C15.7207243,16.035383 15.3066543,16.1235357 15.0316274,16.394999 L13.7551401,17.6692297 C13.4352011,17.988603 12.9409247,18.0552118 12.5476019,17.8319577 C9.87399674,16.3143914 7.66029146,14.1045996 6.14003759,11.4357211 C5.91638808,11.0430936 5.9831148,10.549691 6.30305379,10.2303176 L7.57557543,8.96006784 C7.85148519,8.68154623 7.93979395,8.26820826 7.8008755,7.89928983 C7.43409405,6.91809909 7.179686,5.89863795 7.04376665,4.86957739 C6.97315712,4.37089765 6.54312259,4.00170698 6.0385601,4.00661484 Z"
                                    id="Path"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span className="contact-div">
                      <a href="tel:+1 (999) 999-9999">+1 (999) 999-9999</a>
                    </span>
                  </div>
                  <div className="call-div">
                    <span className="svg-icon">
                      <svg
                        width="22px"
                        height="18px"
                        viewBox="0 0 22 18"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>{t("contact_us.combined_shape")}</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <g
                            className="fill"
                            transform="translate(-375.000000, -652.000000)"
                            fillRule="nonzero"
                          >
                            <g transform="translate(375.000000, 230.000000)">
                              <g transform="translate(0.000000, 258.000000)">
                                <g transform="translate(0.000000, 158.000000)">
                                  <path
                                    d="M19,6 C20.6522847,6 22,7.34771525 22,9 L22,21 C22,22.6522847 20.6522847,24 19,24 L3,24 C1.34771525,24 0,22.6522847 0,21 L0,9 C0,7.34771525 1.34771525,6 3,6 L19,6 Z M19,8 L3,8 C2.45228475,8 2,8.45228475 2,9 L2,21 C2,21.5477153 2.45228475,22 3,22 L19,22 C19.5477153,22 20,21.5477153 20,21 L20,9 C20,8.45228475 19.5477153,8 19,8 Z M1.57346234,8.18076808 C1.12101305,7.86405357 0.497482587,7.97408836 0.180768079,8.42653766 C-0.135946428,8.87898695 -0.0259116406,9.50251741 0.426537656,9.81923192 L10.4265377,16.8192319 C10.7708578,17.060256 11.2291422,17.060256 11.5734623,16.8192319 L21.5734623,9.81923192 C22.0259116,9.50251741 22.1359464,8.87898695 21.8192319,8.42653766 C21.5025174,7.97408836 20.878987,7.86405357 20.4265377,8.18076808 L11,14.7793444 L1.57346234,8.18076808 Z"
                                    id="Combined-Shape"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span className="contact-div">
                      <a
                        href="mailto:support@ilife.tech"
                        target="_top"
                        rel="noopener"
                      >
                        support@ilife.tech
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="contact-dropbox">
                <h2>{t("contact_us.drop_us_a_line!")}</h2>
                <Form>
                  <div className="form-group">
                    <div className="input-effect">
                      <input
                        className="form-control"
                        placeholder={t("contact_us.full_name")}
                        type="text"
                      />
                      <label>{t("contact_us.full_name")}</label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-effect">
                      <input
                        className="form-control"
                        placeholder={t("contact_us.email_address")}
                        type="email"
                      />
                      <label>{t("contact_us.email_address")}</label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-effect">
                      <NumberFormat
                        className="form-control"
                        placeholder={t("contact_us.mobile_no")}
                        type="tel"
                        format="(###) ###-####"
                      />
                      <label>{t("contact_us.mobile_no")}</label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="input-effect">
                      <textarea
                        className="form-control"
                        placeholder={t("contact_us.message")}
                      ></textarea>
                      <label>{t("contact_us.message")}</label>
                    </div>
                  </div>

                  <div className="form-group mb-0 text-center">
                    <Button variant="primary" className="btn-lg">
                      {t("contact_us.submit")}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End: Contanct Box */}
    </React.Fragment>
  );
};

export default ContactUs;
